module.exports = __webpack_public_path__ + "static/img/indicate.88d9d603.png";